import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/dashboard");
    } catch {
      toast.error("Invalid email or password.");
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-28 md:pt-32 pb-24 min-h-screen" data-testid="page-login">
      <div className="max-w-md mx-auto px-6">
        <div className="flex items-center gap-3 mb-6">
          <span className="rule-gold" /><span className="eyebrow">Sign in</span>
        </div>
        <h1 className="serif text-5xl leading-none">Welcome back.</h1>

        <button onClick={googleLogin} data-testid="login-google-btn"
          className="mt-8 w-full flex items-center justify-center gap-3 border border-[#0d1b3e]/20 bg-white py-3 hover:border-[#b8892b] transition-colors">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          <span className="text-sm font-semibold uppercase tracking-[0.14em]">Continue with Google</span>
        </button>

        <div className="my-8 flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-[#4a5570]">
          <span className="flex-1 h-px bg-[#0d1b3e]/15" /> or email <span className="flex-1 h-px bg-[#0d1b3e]/15" />
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.22em] text-[#4a5570]">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-1 w-full border border-[#0d1b3e]/20 bg-white px-3 py-2 outline-none focus:border-[#b8892b]" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.22em] text-[#4a5570]">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-1 w-full border border-[#0d1b3e]/20 bg-white px-3 py-2 outline-none focus:border-[#b8892b]" />
          </div>
          <button disabled={busy} type="submit" data-testid="login-submit"
            className="btn-sharp btn-sharp-gold w-full justify-center">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-6 text-sm text-[#4a5570]">
          New here? <Link to="/signup" className="text-[#0d1b3e] underline decoration-[#b8892b]">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
